"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.X_LEADING_PAYMENTS = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("react");

var _propTypes = require("prop-types");

var _react2 = require("@emotion/react");

var _core = require("@material-ui/core");

var _InfoOutlined = _interopRequireDefault(require("@material-ui/icons/InfoOutlined"));

var _moment = _interopRequireDefault(require("moment"));

var css = _interopRequireWildcard(require("./PaymentSchedule.styles"));

var _PaymentSchedule2 = require("./PaymentSchedule.types");

var Buttons = _interopRequireWildcard(require("../../../components/input/button/Button"));

var _Icon = require("../../../components/icon/Icon");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// How many leading payments to show regardless of `expanded` state
var X_LEADING_PAYMENTS = 2;
exports.X_LEADING_PAYMENTS = X_LEADING_PAYMENTS;

var filtered = function filtered(payments) {
  // The payments we always show, regardless of `expanded` state
  var range = [].concat(_toConsumableArray(Array(X_LEADING_PAYMENTS).keys()), [payments.length - 1]);
  return {
    repayments: payments.filter(function (payment, i) {
      return !payment.isFee && !range.includes(i);
    }).length,
    fees: payments.filter(function (payment, i) {
      return payment.isFee && !range.includes(i);
    }).length
  };
};

var Payment = function Payment(_ref) {
  var amount = _ref.amount,
      date = _ref.date,
      isFee = _ref.isFee,
      isLoading = _ref.isLoading,
      isTruncated = _ref.isTruncated,
      label = _ref.label,
      onFeeClick = _ref.onFeeClick,
      instalmentNumber = _ref.instalmentNumber,
      paymentCount = _ref.paymentCount,
      _ref$paymentType = _ref.paymentType,
      paymentType = _ref$paymentType === void 0 ? _PaymentSchedule2.PaymentType.Repayment : _ref$paymentType,
      hasNothingToPayToday = _ref.hasNothingToPayToday;
  return (0, _jsxRuntime.jsxs)("li", {
    children: [(0, _jsxRuntime.jsxs)("span", {
      css: css.amount(Math.min(paymentCount, hasNothingToPayToday ? X_LEADING_PAYMENTS + 1 : X_LEADING_PAYMENTS), isLoading, isTruncated, instalmentNumber),
      children: [(0, _jsxRuntime.jsx)("span", {
        css: isLoading && css.mask,
        children: amount >= 0 && "$".concat(amount.toFixed(isFee && amount % 1 === 0 || amount === 0 ? 0 : 2)).concat(isFee ? ' fee' : '')
      }), isFee && onFeeClick && (0, _jsxRuntime.jsx)("button", {
        css: css.iconButton,
        onClick: onFeeClick,
        type: "button",
        "aria-label": "info",
        children: (0, _jsxRuntime.jsx)(_core.SvgIcon, {
          css: css.icon,
          component: _InfoOutlined["default"],
          titleAccess: "info"
        })
      })]
    }), (0, _jsxRuntime.jsxs)("span", {
      css: css.description,
      children: [(0, _jsxRuntime.jsx)("small", {
        css: isLoading && css.mask,
        children: date && "".concat(paymentType === _PaymentSchedule2.PaymentType.Instalment ? 'Due ' : '', " ").concat((0, _moment["default"])(date).format('D MMM YYYY'))
      }), label && (0, _jsxRuntime.jsx)("small", {
        css: css.label,
        children: label
      })]
    })]
  });
};

var NothingToPayToday = function NothingToPayToday(_ref2) {
  var isLoading = _ref2.isLoading,
      isInstallments = _ref2.isInstallments;
  return (0, _jsxRuntime.jsxs)("li", {
    css: css.payNothingItem,
    children: [(0, _jsxRuntime.jsx)(_Icon.Tick, {
      css: css.payNothingIcon
    }), (0, _jsxRuntime.jsx)("span", {
      css: css.nothingToPay(isInstallments),
      children: (0, _jsxRuntime.jsx)("span", {
        css: isLoading && css.mask,
        children: "Nothing to Pay"
      })
    }), (0, _jsxRuntime.jsx)("span", {
      css: css.description,
      children: (0, _jsxRuntime.jsx)("small", {
        css: isLoading && css.mask,
        children: "Today"
      })
    })]
  });
};

var PaymentSchedule = function PaymentSchedule(_ref3) {
  var isLoading = _ref3.isLoading,
      onFeeClick = _ref3.onFeeClick,
      payments = _ref3.payments,
      _ref3$paymentType = _ref3.paymentType,
      paymentType = _ref3$paymentType === void 0 ? _PaymentSchedule2.PaymentType.Repayment : _ref3$paymentType,
      _ref3$hasNothingToPay = _ref3.hasNothingToPayToday,
      hasNothingToPayToday = _ref3$hasNothingToPay === void 0 ? false : _ref3$hasNothingToPay,
      props = _objectWithoutProperties(_ref3, ["isLoading", "onFeeClick", "payments", "paymentType", "hasNothingToPayToday"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(filtered(payments)),
      _useState4 = _slicedToArray(_useState3, 2),
      filteredPayments = _useState4[0],
      set = _useState4[1];

  var finalPayment = payments[payments.length - 1];
  (0, _react.useEffect)(function () {
    setExpanded(false);
    set(filtered(payments));
  }, [payments]);
  var theme = (0, _react2.useTheme)();
  return (0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    css: [css.paymentSchedule, {
      backgroundColor: paymentType === _PaymentSchedule2.PaymentType.Instalment && theme.colors.neutral[0],
      border: paymentType === _PaymentSchedule2.PaymentType.Instalment ? '' : "solid 1px ".concat(theme.colors.neutral[100])
    }]
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)("ul", {
      css: css.payments,
      children: [!isLoading && hasNothingToPayToday && (0, _jsxRuntime.jsx)(NothingToPayToday, {
        isLoading: isLoading,
        isInstallments: paymentType === _PaymentSchedule2.PaymentType.Instalment
      }), payments.length > 1 && payments.slice(0, expanded ? payments.length - 1 : Math.min(X_LEADING_PAYMENTS, payments.length - 1)).map(function (_ref4, i) {
        var amount = _ref4.amount,
            date = _ref4.date,
            isFee = _ref4.isFee,
            label = _ref4.label;
        return (0, _jsxRuntime.jsx)(Payment, {
          amount: amount,
          date: date,
          expanded: expanded,
          isFee: isFee,
          isLoading: isLoading,
          isTruncated: !expanded && !isLoading && filteredPayments.repayments + filteredPayments.fees > 0 // We re-render the entire list when the data changes so it's safe to use the array index as a key here
          // eslint-disable-next-line react/no-array-index-key
          ,
          label: label,
          onFeeClick: onFeeClick,
          instalmentNumber: paymentType === _PaymentSchedule2.PaymentType.Instalment ? i : undefined,
          paymentCount: payments.length,
          paymentType: paymentType,
          hasNothingToPayToday: hasNothingToPayToday
        }, "".concat(amount, "-").concat(i));
      }), !expanded && !isLoading && (filteredPayments.repayments > 0 || filteredPayments.fees > 0) && (0, _jsxRuntime.jsx)("li", {
        children: (0, _jsxRuntime.jsxs)(Buttons.Text, {
          className: "body2",
          css: css.paymentSummary,
          onClick: function onClick() {
            return setExpanded(true);
          },
          children: ["+", filteredPayments.repayments > 0 && " ".concat(filteredPayments.repayments, " ").concat(paymentType), filteredPayments.repayments > 1 ? 's ' : '', filteredPayments.repayments > 0 && filteredPayments.fees > 0 && ' and', filteredPayments.fees > 0 && " ".concat(filteredPayments.fees, " fee"), filteredPayments.fees > 1 ? 's' : '']
        })
      }), (0, _jsxRuntime.jsx)(Payment, {
        amount: finalPayment.amount,
        date: finalPayment.date,
        instalmentNumber: paymentType === _PaymentSchedule2.PaymentType.Instalment ? payments.length - 1 : undefined,
        isFee: finalPayment.isFee,
        isLoading: isLoading,
        label: finalPayment.label,
        paymentCount: payments.length,
        hasNothingToPayToday: hasNothingToPayToday
      })]
    })
  }));
};

Payment.propTypes = {
  amount: _propTypes.number.isRequired,
  date: _propTypes.string.isRequired,
  instalmentNumber: _propTypes.number,
  isFee: _propTypes.bool,
  isLoading: _propTypes.bool,
  isTruncated: _propTypes.bool,
  label: _propTypes.string,
  onFeeClick: _propTypes.func,
  paymentCount: _propTypes.number.isRequired
};
PaymentSchedule.propTypes = {
  isLoading: _propTypes.bool,
  onFeeClick: _propTypes.func,
  payments: (0, _propTypes.arrayOf)((0, _propTypes.exact)({
    amount: _propTypes.number.isRequired,
    date: _propTypes.string.isRequired,
    isFee: _propTypes.bool,
    label: _propTypes.string.isRequired
  }).isRequired).isRequired
};
Payment.defaultProps = {
  instalmentNumber: undefined,
  isFee: false,
  isLoading: false,
  isTruncated: false,
  label: undefined,
  onFeeClick: undefined
};
PaymentSchedule.defaultProps = {
  isLoading: false,
  onFeeClick: undefined
};
var _default = PaymentSchedule;
exports["default"] = _default;